import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCancellationTokenSource } from './cancellation';
var noop = function noop() {
  /**/
};

/**
 * Debounces a promise. Passes in a `CancellationToken` as the last parameter.
 */
export function debouncePromise(fn) {
  var source = null;
  var calls = 0;
  var deferreds = [];
  var innerPromise = null;
  function resolveAll(result) {
    deferreds.forEach(function (d) {
      return d.resolve(result);
    });
    deferreds = [];
  }
  function rejectAll(error) {
    deferreds.forEach(function (d) {
      return d.reject(error);
    });
    deferreds = [];
  }
  function debounced() {
    return _debounced.apply(this, arguments);
  }
  function _debounced() {
    _debounced = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this = this;
      var _len,
        args,
        _key,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args2[_key];
            }
            return _context2.abrupt("return", new Promise(/*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                var currentCall, token, result;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      deferreds.push({
                        resolve: resolve,
                        reject: reject
                      });
                      currentCall = ++calls;
                      if (source) {
                        source.cancel();
                      }
                      source = createCancellationTokenSource();
                      token = source.token;
                      if (!innerPromise) {
                        _context.next = 10;
                        break;
                      }
                      _context.next = 8;
                      return innerPromise.catch(noop);
                    case 8:
                      if (!(calls !== currentCall)) {
                        _context.next = 10;
                        break;
                      }
                      return _context.abrupt("return");
                    case 10:
                      _context.prev = 10;
                      innerPromise = Promise.resolve().then(function () {
                        return fn.apply(_this, [].concat(args, [token]));
                      });
                      _context.next = 14;
                      return innerPromise;
                    case 14:
                      result = _context.sent;
                      if (!(calls !== currentCall)) {
                        _context.next = 17;
                        break;
                      }
                      return _context.abrupt("return");
                    case 17:
                      resolveAll(result);
                      _context.next = 25;
                      break;
                    case 20:
                      _context.prev = 20;
                      _context.t0 = _context["catch"](10);
                      if (!(calls !== currentCall)) {
                        _context.next = 24;
                        break;
                      }
                      return _context.abrupt("return");
                    case 24:
                      rejectAll(_context.t0);
                    case 25:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[10, 20]]);
              }));
              return function (_x, _x2) {
                return _ref.apply(this, arguments);
              };
            }()));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _debounced.apply(this, arguments);
  }
  return debounced;
}

/**
 * Set timeout with a promise.
 *
 * @param {*} ms
 */
export function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

/**
 * Deferred promise.
 *
 * @returns {{resolve: (function(*): *), reject: (function(*): *), promise: Promise}}
 */
export function defer() {
  var _resolve;
  var _reject;
  var promise = new Promise(function (resolve, reject) {
    _resolve = resolve;
    _reject = reject;
  });
  return {
    promise: promise,
    resolve: function resolve(value) {
      return _resolve(value);
    },
    reject: function reject(error) {
      return _reject(error);
    }
  };
}
//# sourceMappingURL=promiseUtil.js.map
